/* eslint-disable */
import React, { useState } from "react";
import AmarantComponent from "../../components/AmarantComponent/AmarantComponent";
import PaperComponent from "../../components/PaperComponent/PaperComponent";

export default function AmarantPage() {
  const [selectedTab, setSelectedTab] = useState(0);

  // "Грешки" 4.
  const isErrorsTabSelected = selectedTab === 4;

  return (
    <>
      <PaperComponent flexible={isErrorsTabSelected}>
        <AmarantComponent
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      </PaperComponent>
    </>
  );
}
